import styled from "styled-components";
import { BREAKPOINTS } from "../../../app/appConstants";

export const PrivacyPolicyWrapperStyled = styled.div`
    background: var(--app-bg-modal-color);
    padding-bottom: 40px;
`;

export const PrivacyPolicyContentStyled = styled.section`
    max-width: 1360px;
    margin: 0 auto;
    padding: 48px;
    @media (max-width: ${BREAKPOINTS.extraLarge}px) {
        padding: 40px;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        padding: 16px;
    }
    
    h1 {
        text-align: center;
        margin-bottom: 16px;
    }
    
    h2 {
        margin: 40px 0 16px;
    }
    
    b {
        font-weight: 600;
    }
`;